import React 			from 'react';
import PropTypes 		from 'prop-types';
import ReactDOM 		from 'react-dom';
import BLComponent		from '../core/_BLComponent.jsx';

import ModalFrame from '../common/_ModalFrame.jsx';
import {BDPIcon} from '../common/_Icons.jsx';

export default class StudioActivityContent extends BLComponent {
	constructor(props) {
		super(props);

		this.state = {
			showContestInfo: false,
			showModal: false,
			modalType: '',
		};

	}

	render() {
		const {slug} = this.props;

		switch(slug) {
			case 'project-acorn':
				return this.renderProjectAcorn();

			case 'build-a-doghouse':
				return this.renderBuildDoghouse();

			case 'blholiday22':
				return this.renderHoliday22();

			case 'springisbuilding23':
				return this.renderSpring23();

			case 'fallfantasies23':
				return this.renderFall23();

			case 'winterwonderland23':
				return this.renderHoliday23();

			case 'series1minibuild':
				return this.renderBDPSeries1();

			default:
				return this.renderDefault(this.props.activity, this.props.previewMode);
		}
	}

	renderProjectAcorn() {
		return (
			<article data-ts-name="studio-contest__header-block studio-contest__header-block--acorn" className="studio-contest__header-block">
				<section className="studio-contest__intro">
					<div className="studio-contest__intro-body">
						<h1 className="studio-contest__intro-title text--xl-title">Project Acorn</h1>
						<p className="text--small-title l-margin-bottom--xl">Thank you for creating something fun, cheeky, and amazing using the five seed parts to help Bricky explore the world of Studio. Winners of Project Acorn have been announced!</p>
						<div className="studio-contest__dates l-margin-bottom--xl">
							<div className="studio-contest__dates-item">
								<p className="studio-contest__dates-title">Activity ended</p>
								<p className="studio-contest__dates-date">May 18</p>
								<p className="studio-contest__dates-time">2022</p>
							</div>
							<div className="studio-contest__dates-item">
								<p className="studio-contest__dates-title">Winners announced</p>
								<p className="studio-contest__dates-date">June 1</p>
								<p className="studio-contest__dates-time">2022</p>
							</div>
						</div>
						<button className="text--small-title btn btn--link" data-ts-name="show-contest-info__btn" onClick={() => this.setState({showContestInfo: !this.state.showContestInfo})}>{this.state.showContestInfo ? 'Hide' : 'Show'} details<i className={`fas fa-caret-${this.state.showContestInfo ? 'up' : 'down'} l-margin-left--sm`}/></button>
					</div>
					<div className="studio-contest__intro-image studio-contest__intro-image--project-acorn">
						<img src={"//" + blapp.config.getHost( "static2" ) + "/img/studio-gallery/project-acorn-parts.png"} className="studio-contest__intro-image-item" alt="5 new studio parts featuring a squirrel"/>
					</div>
				</section>
				{this.state.showContestInfo &&
					<div className="studio-contest__extra" data-ts-name="show-contest-info__content">
						<section className="studio-contest__extra-item">
							<h2 className="text--small-title text--bold l-margin-bottom--sm"><i className="studio-contest__header-icon fas fa-fw fa-clipboard-list l-margin-right"/>Design Requirements</h2>
							<ul className="studio-contest__list-items dash-list-long l-margin-bottom">
								<li><span>10 to 500 total parts. </span></li>
								<li><span>Unlimited color palette.</span></li>
								<li><span>Use one or more of <strong>each</strong> featured part.</span></li>
							</ul>
							<div className="studio-contest__part-container">
								<article className="studio-contest__part-card contest-part-card">
									<a href="//www.bricklink.com/v2/catalog/catalogitem.page?P=86996" data-ts-name="contest-part-card__link" className="contest-part-card__internal">
										<div className="contest-part-card__image" data-ts-name="contest-part-card__image">
											<img src="//img.bricklink.com/ItemImage/PN/158/86996.png" className="contest-part-card__image-item" alt="Brick, Modified 1 x 1 x 2/3 with Open Stud"/>
										</div>
										<div className="contest-part-card__details">
											<span className="contest-part-card__part-number" data-ts-name="contest-part-card__part-number">86996</span>
											<p className="contest-part-card__part-name" data-ts-name="contest-part-card__part-name">Brick, Modified 1 x 1 x 2/3 with Open Stud</p>
										</div>
									</a>
								</article>
								<article className="studio-contest__part-card contest-part-card">
									<a href="//www.bricklink.com/v2/catalog/catalogitem.page?P=86876" data-ts-name="contest-part-card__link" className="contest-part-card__internal">
										<div className="contest-part-card__image" data-ts-name="contest-part-card__image">
											<img src="//img.bricklink.com/ItemImage/PN/1/86876.png" className="contest-part-card__image-item" alt="Brick, Modified 1 x 2 with Stud on Side"/>
										</div>
										<div className="contest-part-card__details">
											<span className="contest-part-card__part-number" data-ts-name="contest-part-card__part-number">86876</span>
											<p className="contest-part-card__part-name" data-ts-name="contest-part-card__part-name">Brick, Modified 1 x 2 with Stud on Side</p>
										</div>
									</a>
								</article>
								<article className="studio-contest__part-card contest-part-card">
									<a href="//www.bricklink.com/v2/catalog/catalogitem.page?P=79846" data-ts-name="contest-part-card__link l-center" className="contest-part-card__internal">
										<div className="contest-part-card__image" data-ts-name="contest-part-card__image">
											<img src="//img.bricklink.com/ItemImage/PN/4/79846.png" className="contest-part-card__image-item" alt="Plate, Modified 2 x 6 x 2/3 Bent"/>
										</div>
										<div className="contest-part-card__details">
											<span className="contest-part-card__part-number" data-ts-name="contest-part-card__part-number">79846</span>
											<p className="contest-part-card__part-name" data-ts-name="contest-part-card__part-name">Plate, Modified 2 x 6 x 2/3 Bent</p>
										</div>
									</a>
								</article>
								<article className="studio-contest__part-card contest-part-card">
									<a href="//www.bricklink.com/v2/catalog/catalogitem.page?P=77808" data-ts-name="contest-part-card__link" className="contest-part-card__internal">
										<div className="contest-part-card__image" data-ts-name="contest-part-card__image">
											<img src="//img.bricklink.com/ItemImage/PN/115/77808.png" className="contest-part-card__image-item" alt="Brick, Round 1 x 2 with Hollow Studs and Open Center with Bars"/>
										</div>
										<div className="contest-part-card__details">
											<span className="contest-part-card__part-number" data-ts-name="contest-part-card__part-number">77808</span>
											<p className="contest-part-card__part-name" data-ts-name="contest-part-card__part-name">Brick, Round 1 x 2 with Hollow Studs and Open Center with Bars</p>
										</div>
									</a>
								</article>
								<article className="studio-contest__part-card contest-part-card">
									<a href="//www.bricklink.com/v2/catalog/catalogitem.page?P=80679pb01" data-ts-name="contest-part-card__link" className="contest-part-card__internal">
										<div className="contest-part-card__image" data-ts-name="contest-part-card__image">
											<img src="//img.bricklink.com/ItemImage/PN/68/80679pb01.png" className="contest-part-card__image-item" alt="Squirrel with Black Eyes, White Pupils, and Reddish Brown Nose Pattern"/>
										</div>
										<div className="contest-part-card__details">
											<span className="contest-part-card__part-number" data-ts-name="contest-part-card__part-number">80679pb01</span>
											<p className="contest-part-card__part-name" data-ts-name="contest-part-card__part-name">Squirrel with Black Eyes, White Pupils, and Reddish Brown Nose Pattern</p>
										</div>
									</a>
								</article>
							</div>
						</section>
						<section className="studio-contest__extra-item">
							<h2 className="text--small-title text--bold l-margin-bottom--sm"><i className="studio-contest__header-icon fas fa-fw fa-acorn l-margin-right"/>Winners and Recognition</h2>
							<ul className="studio-contest__list-items dash-list-long">
								<li><span>All participating designs display the Project Acorn badge.</span></li>
								<li><span>Winning designs display the Project Acorn Winner badge</span></li>
							</ul>
						</section>
					</div>
				}
			</article>
		);
	}

	renderBuildDoghouse() {
		return (
			<article data-ts-name="studio-contest__header-block studio-contest__header-block--acorn" className="studio-contest__header-block studio-contest__header-block--doghouse">
				<section className="studio-contest__intro">
					<div className="studio-contest__intro-body">
						<h1 className="studio-contest__intro-title text--xl-title">Build a Doghouse</h1>
						<p className="text--small-title l-margin-bottom--xl">Thanks for building a warm, dry home for our dear Studley the Scottie using the using the six seed parts to explore Studio. Check back soon to see the winners of Build a Doghouse!</p>
						<div className="studio-contest__dates l-margin-bottom--xl">
							<div className="studio-contest__dates-item">
								<p className="studio-contest__dates-title">Activity ended</p>
								<p className="studio-contest__dates-date">August 26</p>
								<p className="studio-contest__dates-time">2022</p>
							</div>
							<div className="studio-contest__dates-item">
								<p className="studio-contest__dates-title">Winners announced</p>
								<p className="studio-contest__dates-date">September 15</p>
								<p className="studio-contest__dates-time">2022</p>
							</div>
						</div>
						<button className="text--small-title btn btn--link" data-ts-name="show-contest-info__btn" onClick={() => this.setState({showContestInfo: !this.state.showContestInfo})}>{this.state.showContestInfo ? 'Hide' : 'Show'} details<i className={`fas fa-caret-${this.state.showContestInfo ? 'up' : 'down'} l-margin-left--sm`}/></button>
					</div>
					<picture className="studio-contest__intro-image studio-contest__intro-image--build-a-doghouse">
						<source media="(min-width:840px)" srcSet={"//" + blapp.config.getHost( "static2" ) + "/img/studio-gallery/build-a-doghouse.png"} className="studio-contest__intro-image-item" alt="6 new studio parts featuring a Scottie dog"/>
						<img src={"//" + blapp.config.getHost( "static2" ) + "/img/studio-gallery/build-a-doghouse--mob.png"} className="studio-contest__intro-image-item" alt="6 new studio parts featuring a Scottie dog"/>
					</picture>
				</section>
				{this.state.showContestInfo &&
					<div className="studio-contest__extra" data-ts-name="show-contest-info__content">
						<section className="studio-contest__extra-item">
							<h2 className="text--small-title text--bold l-margin-bottom--sm"><i className="studio-contest__header-icon fas fa-fw fa-clipboard-list l-margin-right"/>Design Requirements</h2>
							<ul className="studio-contest__list-items dash-list-long l-margin-bottom">
								<li><span>10 to 500 total parts. </span></li>
								<li><span>Unlimited color palette.</span></li>
								<li><span>Use one or more of <strong>each</strong> featured part.</span></li>
							</ul>
							<div className="studio-contest__part-container">
								<article className="studio-contest__part-card contest-part-card">
									<a href="//www.bricklink.com/v2/catalog/catalogitem.page?P=83496" data-ts-name="contest-part-card__link" className="contest-part-card__internal">
										<div className="contest-part-card__image" data-ts-name="contest-part-card__image">
											<img src="//img.bricklink.com/ItemImage/EXTN/50073.png" className="contest-part-card__image-item" alt="Tile, Modified 4 x 8 Inverted with Studs on Edges"/>
										</div>
										<div className="contest-part-card__details">
											<span className="contest-part-card__part-number" data-ts-name="contest-part-card__part-number">83496</span>
											<p className="contest-part-card__part-name" data-ts-name="contest-part-card__part-name">Tile, Modified 4 x 8 Inverted with Studs on Edges</p>
										</div>
									</a>
								</article>
								<article className="studio-contest__part-card contest-part-card">
									<a href="//www.bricklink.com/v2/catalog/catalogitem.page?P=80796" data-ts-name="contest-part-card__link" className="contest-part-card__internal">
										<div className="contest-part-card__image" data-ts-name="contest-part-card__image">
											<img src="//img.bricklink.com/ItemImage/PL/80796.png" className="contest-part-card__image-item" alt="Brick, Modified 1 x 2 x 1 2/3 with Studs on Sides"/>
										</div>
										<div className="contest-part-card__details">
											<span className="contest-part-card__part-number" data-ts-name="contest-part-card__part-number">80796</span>
											<p className="contest-part-card__part-name" data-ts-name="contest-part-card__part-name">Brick, Modified 1 x 2 x 1 2/3 with Studs on Sides</p>
										</div>
									</a>
								</article>
								<article className="studio-contest__part-card contest-part-card">
									<a href="//www.bricklink.com/v2/catalog/catalogitem.page?P=26078pb002" data-ts-name="contest-part-card__link l-center" className="contest-part-card__internal">
										<div className="contest-part-card__image" data-ts-name="contest-part-card__image">
											<img src="//img.bricklink.com/ItemImage/PL/26078pb002.png" className="contest-part-card__image-item" alt=""/>
										</div>
										<div className="contest-part-card__details">
											<span className="contest-part-card__part-number" data-ts-name="contest-part-card__part-number">26078pb002</span>
											<p className="contest-part-card__part-name" data-ts-name="contest-part-card__part-name">Dog, Terrier with Black Eyes and Nose and Light Bluish Gray Fur Lines Pattern (Toto)</p>
										</div>
									</a>
								</article>
								<article className="studio-contest__part-card contest-part-card">
									<a href="//www.bricklink.com/v2/catalog/catalogitem.page?P=89681" data-ts-name="contest-part-card__link" className="contest-part-card__internal">
										<div className="contest-part-card__image" data-ts-name="contest-part-card__image">
											<img src="//img.bricklink.com/ItemImage/PL/89681.png" className="contest-part-card__image-item" alt="Plate, Modified 4 x 6 with 2 x 2 Cutout and Round Corner 2 x 6 Double"/>
										</div>
										<div className="contest-part-card__details">
											<span className="contest-part-card__part-number" data-ts-name="contest-part-card__part-number">89681</span>
											<p className="contest-part-card__part-name" data-ts-name="contest-part-card__part-name">Plate, Modified 4 x 6 with 2 x 2 Cutout and Round Corner 2 x 6 Double</p>
										</div>
									</a>
								</article>
								<article className="studio-contest__part-card contest-part-card">
									<a href="//www.bricklink.com/v2/catalog/catalogitem.page?P=79756" data-ts-name="contest-part-card__link" className="contest-part-card__internal">
										<div className="contest-part-card__image" data-ts-name="contest-part-card__image">
											<img src="//img.bricklink.com/ItemImage/PL/79756.png" className="contest-part-card__image-item" alt="Slope, Curved 1 x 4 x 2/3 Double"/>
										</div>
										<div className="contest-part-card__details">
											<span className="contest-part-card__part-number" data-ts-name="contest-part-card__part-number">79756</span>
											<p className="contest-part-card__part-name" data-ts-name="contest-part-card__part-name">Slope, Curved 1 x 4 x 2/3 Double</p>
										</div>
									</a>
								</article>
								<article className="studio-contest__part-card contest-part-card">
									<a href="//www.bricklink.com/v2/catalog/catalogitem.page?P=76797" data-ts-name="contest-part-card__link" className="contest-part-card__internal">
										<div className="contest-part-card__image" data-ts-name="contest-part-card__image">
											<img src="//img.bricklink.com/ItemImage/PL/76797.png" className="contest-part-card__image-item" alt="Slope, Curved 3 x 3 Corner"/>
										</div>
										<div className="contest-part-card__details">
											<span className="contest-part-card__part-number" data-ts-name="contest-part-card__part-number">76797</span>
											<p className="contest-part-card__part-name" data-ts-name="contest-part-card__part-name">Slope, Curved 3 x 3 Corner</p>
										</div>
									</a>
								</article>
							</div>
						</section>
						<section className="studio-contest__extra-item">
							<h2 className="text--small-title text--bold l-margin-bottom--sm"><i className="studio-contest__header-icon fas fa-fw fa-upload l-margin-right"/>Submission Specifications</h2>
							<ul className="studio-contest__list-items dash-list-long">
								<li><span>Select <strong>Partial Access</strong> or <strong>Full Access</strong></span></li>
								<li><span>Add <strong>buildADoghouse</strong> tag</span></li>
								<li><span>Designs must be 100% original and not use third-party IP.</span></li>
							</ul>
						</section>
						<section className="studio-contest__extra-item">
							<h2 className="text--small-title text--bold l-margin-bottom--sm"><i className="studio-contest__header-icon fas fa-fw fa-bone l-margin-right"/>Winners and Recognition</h2>
							<ul className="studio-contest__list-items dash-list-long">
								<li><span>All participating designs display the Build a Doghouse badge.</span></li>
								<li><span>Winning designs display the Build a Doghouse badge.</span></li>
							</ul>
						</section>
					</div>
				}
			</article>
		);
	}

	renderHoliday22() {
		return (
			<article data-ts-name="studio-contest__header-block studio-contest__header-block--holiday-22" className="studio-contest__header-block studio-contest__header-block--holiday-22">
				{this.state.showModal && this.state.modalType == 'holiday' ? this.renderModal() : null}
				<section className="studio-contest__intro">
					<div className="studio-contest__intro-body">
						<h1 className="studio-contest__intro-title text--xl-title">Brilliant Brick Ornament 2022</h1>
						<p className="text--small-title l-margin-bottom">Looking for a fun and festive way to celebrate the holidays this year? Build a brilliant brick ornament! To enter, simply create your ornament in BrickLink Studio using the BrickLink Common Palette. This way, your ornament will be easy to order in the Marketplace and make its way to trees all around the world!</p>
						<p className="text--small-title l-margin-bottom--xl">Need some inspiration? We’ve included a template for an optional base to help you get started. <a href="https://bricklink.download.bricklink.info/brick_ornament_template.io">Download template</a>.</p>
						<div className="studio-contest__dates l-margin-bottom--xl">
							<div className="studio-contest__dates-item">
								<p className="studio-contest__dates-title">Activity ended</p>
								<p className="studio-contest__dates-date">December 16</p>
								<p className="studio-contest__dates-time">2022</p>
							</div>
							<div className="studio-contest__dates-item">
								<p className="studio-contest__dates-title">Winners announced</p>
								<p className="studio-contest__dates-date">January 5</p>
								<p className="studio-contest__dates-time">2023</p>
							</div>
						</div>
						<button className="text--small-title btn btn--link" data-ts-name="show-contest-info__btn" onClick={() => this.setState({showContestInfo: !this.state.showContestInfo})}>{this.state.showContestInfo ? 'Hide' : 'Show'} details<i className={`fas fa-caret-${this.state.showContestInfo ? 'up' : 'down'} l-margin-left--sm`}/></button>
					</div>
					<picture className="studio-contest__intro-image studio-contest__intro-image--holiday-22">
						<img src={"//" + blapp.config.getHost( "static2" ) + "/img/studio-gallery/holiday-22.png"} className="studio-contest__intro-image-item" alt="A Holiday ornament in the shape of a penguin head"/>
					</picture>
				</section>
				{this.state.showContestInfo &&
					<div className="studio-contest__extra" data-ts-name="show-contest-info__content">
						<section className="studio-contest__extra-item studio-contest__extra-item--side-by-side">
							<div className="studio-contest__left-content">
								<h2 className="text--small-title text--bold l-margin-bottom--sm"><i className="studio-contest__header-icon fas fa-fw fa-clipboard-list l-margin-right"/>Design Requirements</h2>
								<ul className="studio-contest__list-items dash-list-long l-margin-bottom">
									<li><span>10 to 75 total parts.</span></li>
									<li><span>Use parts and colors from the BrickLink Common Palette.</span></li>
								</ul>
							</div>
							<div className="studio-contest__right-content">
								<article className="studio-contest__callout">
									<h2 className="text--small-title text--bold l-margin-bottom"><i className="far fa-palette l-margin-right--sm"/>BrickLink Common Palette</h2>
									<p>The BrickLink Common Palette only includes elements and colors that are plentiful in the Marketplace. Tis the Season of Giving - use the BrickLink Common Palette for this activity and other creations so you can source and buy the parts you need to realize your creations in real life! </p>
									<button className="btn btn--link l-margin-top l-margin-bottom" onClick={() => this.toggleModal('holiday')}>Learn how to use the palette<i className="fas fa-long-arrow-right l-margin-left--sm"/></button>
								</article>
							</div>
						</section>
						<section className="studio-contest__extra-item">
							<h2 className="text--small-title text--bold l-margin-bottom--sm"><i className="studio-contest__header-icon fas fa-fw fa-upload l-margin-right"/>Submission Specifications</h2>
							<ul className="studio-contest__list-items dash-list-long">
								<li>All photo submissions must be rendered images that are 1280x960 px max and 4:3 dimensions.</li>
								<li><span>Select <strong>Partial Access</strong> or <strong>Full Access</strong></span></li>
								<li><span>Add <strong>blholiday22</strong> tag</span></li>
								<li><span>Designs must be 100% original and not use third-party IP (for example, no licensed elements like Star Wars figures ... sorry!).</span></li>
								<li><span><strong>Extra credit:</strong> Build it for real and share on Instagram! Take a photo of your physical ornament and post using the hashtag <strong>#BLHoliday22</strong></span></li>
							</ul>
						</section>
						<section className="studio-contest__extra-item">
							<h2 className="text--small-title text--bold l-margin-bottom--sm"><i className="studio-contest__header-icon fas fa-fw fa-gift l-margin-right"/>Winners and Recognition</h2>
							<ul className="studio-contest__list-items dash-list-long">
								<li><span>All participating designs display the Brilliant Brick Ornament 2022 badge.</span></li>
								<li><span>Winning designs display the Brilliant Brick Ornament 2022 winner badge.</span></li>
							</ul>
						</section>
					</div>
				}
			</article>
		);
	}

	renderSpring23() {
		return (
			<article data-ts-name="studio-contest__header-block studio-contest__header-block--spring-23" className="studio-contest__header-block studio-contest__header-block--spring-23">
				<section className="studio-contest__intro">
					<div className="studio-contest__intro-body">
						<h1 className="studio-contest__intro-title text--xl-title">Spring is Building</h1>
						<p className="text--small-title l-margin-bottom--xl">Spring is in the air. With this activity, we’re helping you take a leap forward with your Studio skills, and <a href="https://studiohelp.bricklink.com/hc/en-us/articles/5457935385239-Importing-an-official-LEGO-set-as-a-palette" target="_blank" className="text--underline">learn how to import an official LEGO set as a Palette</a>. Choose one of the three sets and create an alternate, Spring-themed model from the pieces. Once you’ve imported the set as a Palette, it’ll be easy to choose the bricks and design your model. Spring is about rebirth, and we can’t wait to see what new life you breathe into these bricks!</p>
						<div className="studio-contest__dates l-margin-bottom--xl">
							<div className="studio-contest__dates-item">
								<p className="studio-contest__dates-title">Activity ended</p>
								<p className="studio-contest__dates-date">May 24</p>
								<p className="studio-contest__dates-time">12:00 PM PT</p>
							</div>
							<div className="studio-contest__dates-item">
								<p className="studio-contest__dates-title">Winners announced</p>
								<p className="studio-contest__dates-date">June 7</p>
								<p className="studio-contest__dates-time">12:00 PM PT</p>
							</div>
						</div>
						<button className="text--small-title btn btn--link" data-ts-name="show-contest-info__btn" onClick={() => this.setState({showContestInfo: !this.state.showContestInfo})}>{this.state.showContestInfo ? 'Hide' : 'Show'} details<i className={`fas fa-caret-${this.state.showContestInfo ? 'up' : 'down'} l-margin-left--sm`}/></button>
					</div>
					<picture className="studio-contest__intro-image studio-contest__intro-image--spring-23">
						<img src={"//" + blapp.config.getHost( "static2" ) + "/img/studio-gallery/springbuilding23.png"} className="studio-contest__intro-image-item" alt="Three animal LEGO sets with floral images scattered behind"/>
					</picture>
				</section>
				{this.state.showContestInfo &&
					<div className="studio-contest__extra" data-ts-name="show-contest-info__content">
						<section className="studio-contest__extra-item studio-contest__extra-item--side-by-side">
							<div className="studio-contest__left-content">
								<h2 className="text--small-title text--bold l-margin-bottom--sm"><i className="studio-contest__header-icon fas fa-fw fa-clipboard-list l-margin-right"/>Design Requirements</h2>
								<ul className="studio-contest__list-items dash-list-long l-margin-bottom">
									<li><span>100 to 478 total parts</span></li>
									<li><span>Use parts from <strong>ONE</strong> of these three official LEGO sets: <a href="//www.bricklink.com/v2/catalog/catalogitem.page?S=41742-1" className="text--underline">Cat Hotel</a>, <a href="//www.bricklink.com/v2/catalog/catalogitem.page?S=31136-1" className="text--underline">Exotic Parrot</a>, or <a href="//www.bricklink.com/v2/catalog/catalogitem.page?S=31143-1" className="text--underline">Bird House</a>.</span></li>
									<li><span><strong>NOTE:</strong> You may only use parts from <strong className="text--underline">one</strong> of the three sets. We don’t accept builds that combine parts from more than one of these sets.</span></li>
								</ul>
								<div className="studio-contest__part-container l-margin-bottom--sm">
									<article className="studio-contest__part-card contest-part-card">
										<a href="//www.bricklink.com/v2/catalog/catalogitem.page?S=41742-1" data-ts-name="contest-part-card__link" className="contest-part-card__internal">
											<div className="contest-part-card__image" data-ts-name="contest-part-card__image">
												<img src="//img.bricklink.com/ItemImage/ON/0/41742-1.png" className="contest-part-card__image-item" alt="Brick, Modified 1 x 1 x 2/3 with Open Stud"/>
											</div>
											<div className="contest-part-card__details">
												<span className="contest-part-card__part-number" data-ts-name="contest-part-card__part-number">41742-1</span>
												<p className="contest-part-card__part-name" data-ts-name="contest-part-card__part-name">Cat Hotel</p>
											</div>
										</a>
									</article>
									<article className="studio-contest__part-card contest-part-card">
										<a href="//www.bricklink.com/v2/catalog/catalogitem.page?S=31136-1" data-ts-name="contest-part-card__link" className="contest-part-card__internal">
											<div className="contest-part-card__image" data-ts-name="contest-part-card__image">
												<img src="//img.bricklink.com/ItemImage/ON/0/31136-1.png" className="contest-part-card__image-item" alt="Brick, Modified 1 x 2 with Stud on Side"/>
											</div>
											<div className="contest-part-card__details">
												<span className="contest-part-card__part-number" data-ts-name="contest-part-card__part-number">31136-1</span>
												<p className="contest-part-card__part-name" data-ts-name="contest-part-card__part-name">Exotic Parrot</p>
											</div>
										</a>
									</article>
									<article className="studio-contest__part-card contest-part-card">
										<a href="//www.bricklink.com/v2/catalog/catalogitem.page?S=31143-1" data-ts-name="contest-part-card__link l-center" className="contest-part-card__internal">
											<div className="contest-part-card__image" data-ts-name="contest-part-card__image">
												<img src="//img.bricklink.com/ItemImage/ON/0/31143-1.png" className="contest-part-card__image-item" alt="Plate, Modified 2 x 6 x 2/3 Bent"/>
											</div>
											<div className="contest-part-card__details">
												<span className="contest-part-card__part-number" data-ts-name="contest-part-card__part-number">31143-1</span>
												<p className="contest-part-card__part-name" data-ts-name="contest-part-card__part-name">Birdhouse</p>
											</div>
										</a>
									</article>
								</div>
								<div className="notification notification--notice l-full-width l-flex l-border border-color--primaryBlue">
									<i className="notification__icon fas fa-info-circle l-margin-right l-margin-top--xs"/>
									<p><strong>Learn how to import an official LEGO Set as a Palette.</strong><a href="https://studiohelp.bricklink.com/hc/en-us/articles/5457935385239-Importing-an-official-LEGO-set-as-a-palette" target="_blank" className="text--bold text--underline l-margin-left--sm">Learn how</a></p>
								</div>
							</div>
						</section>
						<section className="studio-contest__extra-item">
							<h2 className="text--small-title text--bold l-margin-bottom--sm"><i className="studio-contest__header-icon fas fa-fw fa-upload l-margin-right"/>How to Submit</h2>
							<ul className="studio-contest__list-items dash-list-long">
								<li><span>Upload your design by May 24th, 2023 at 12:00 pm Pacific US Time</span></li>
								<li><span>All photo submissions must be high resolution rendered images that are 1280x960 px max and utilize 4:3 dimensions</span></li>
								<li><span>Select <strong>Partial Access</strong> or <strong>Full Access</strong></span></li>
								<li><span>To enter, you must add the <strong>springisbuilding23</strong> tag</span></li>
								<li><span>Designs must be 100% original and not use third-party IP.</span></li>
							</ul>
						</section>
						<section className="studio-contest__extra-item">
							<h2 className="text--small-title text--bold l-margin-bottom--sm"><i className="studio-contest__header-icon fas fa-fw fa-gift l-margin-right"/>Winners and Recognition</h2>
							<ul className="studio-contest__list-items dash-list-long">
								<li><span>All participating designs will display the Spring is Building ‘23 badge.</span></li>
								<li><span>Winning designs will display their respective Spring is Building ‘23 winner badges.</span></li>
								<li><span>Winners will be announced on <strong>June 7th, 2023</strong>. We’ll feature the winners on social media and in a future Studio Newsletter.</span></li>
							</ul>
						</section>
					</div>
				}
			</article>
		);
	}

	renderFall23() {
		const isClosed = blapp.config.server_time >= new Date('2023-11-27T12:00:00').getTime();

		return (
			<article data-ts-name="studio-contest__header-block studio-contest__header-block--fall-23" className="studio-contest__header-block studio-contest__header-block--fall-23">
				<section className="studio-contest__intro">
					<div className="studio-contest__intro-body">
						<h1 className="studio-contest__intro-title text--xl-title">Festive Fall Fantasies</h1>
						<p className="text--small-title l-margin-bottom--xl">You're invited to build and share your Festive Fall Fantasies during our new fall activity. Whether it's a whimsical woodland, a mythical creature frolicking among fallen leaves, or an enchanted pumpkin carriage, let your imagination howl like the wind. Showcase your creativity, hone your building skills, and celebrate the splendor of the season. Build your autumnal dreams to life!</p>
						<div className="studio-contest__dates l-margin-bottom--xl">
							{!isClosed && 
								<div className="studio-contest__dates-item">
									<p className="studio-contest__dates-title">Activity starts</p>
									<p className="studio-contest__dates-date">October 26</p>
									<p className="studio-contest__dates-time">12:00 PM PT</p>
								</div>
							}
							<div className="studio-contest__dates-item">
								<p className="studio-contest__dates-title">{isClosed ? 'Activity ended' : 'Activity ends'}</p>
								<p className="studio-contest__dates-date">November 27</p>
								<p className="studio-contest__dates-time">12:00 PM PT</p>
							</div>
							{isClosed && 
								<div className="studio-contest__dates-item">
									<p className="studio-contest__dates-title">Winners announced</p>
									<p className="studio-contest__dates-date">December 5</p>
									<p className="studio-contest__dates-time">12:00 PM PT</p>
								</div>
							}
						</div>
						<button className="text--small-title btn btn--link" data-ts-name="show-contest-info__btn" onClick={() => this.setState({showContestInfo: !this.state.showContestInfo})}>{this.state.showContestInfo ? 'Hide' : 'Show'} details<i className={`fas fa-caret-${this.state.showContestInfo ? 'up' : 'down'} l-margin-left--sm`}/></button>
					</div>
					<picture className="studio-contest__intro-image studio-contest__intro-image--spring-23">
						<img src={"//" + blapp.config.getHost( "static2" ) + "/img/studio-gallery/fall-2023-cat.png"} className="studio-contest__intro-image-item" alt="A black cat sitting with fall leaves behind it"/>
					</picture>
				</section>
				{this.state.showContestInfo &&
					<div className="studio-contest__extra" data-ts-name="show-contest-info__content">
						<section className="studio-contest__extra-item studio-contest__extra-item--side-by-side">
							<div className="studio-contest__left-content">
								<h2 className="text--small-title text--bold l-margin-bottom--sm"><i className="studio-contest__header-icon fas fa-fw fa-clipboard-list l-margin-right"/>Design Requirements</h2>
								<ul className="studio-contest__list-items dash-list-long l-margin-bottom">
									<li><span>25 to 500 total parts</span></li>
									<li><span><strong>Bonus, but not required:</strong> Use the BDP Series 3 Palette. This will significantly bring down the price of parts if you plan to realize your creation.</span></li>
								</ul>
								<div className="notification notification--notice l-full-width l-flex l-border border-color--primaryBlue">
									<i className="notification__icon fas fa-info-circle l-margin-right l-margin-top--xs"/>
									<p><strong>Need some inspiration?</strong> Use Studio’s Reference Image feature and utilize one of your favorite Fall photos. <a href="https://studiohelp.bricklink.com/hc/en-us/articles/15341721435799-Reference-Image" target="_blank" className="text--bold text--underline l-margin-left--xs">Learn more</a></p>
								</div>
							</div>
						</section>
						<section className="studio-contest__extra-item">
							<h2 className="text--small-title text--bold l-margin-bottom--sm"><i className="studio-contest__header-icon fas fa-fw fa-upload l-margin-right"/>How to Submit</h2>
							<ul className="studio-contest__list-items dash-list-long">
								{!isClosed && <li><span>Upload your design by November 27th, 2023 at 12:00 pm Pacific US Time</span></li>}
								<li><span>All photo submissions must be rendered images that are 1280x960px max and 4:3 dimensions</span></li>
								<li><span>Select <strong>Partial Access</strong> or <strong>Full Access</strong></span></li>
								<li><span>To enter, you must add the <strong>fallfantasies23</strong> tag</span></li>
								<li><span>Designs must be 100% original and not use third-party IP</span></li>
								<li><span><strong>Extra credit:</strong> Build it for real and share on Instagram! Take a photo of your physical ornament and post using the hashtag <strong>#BLfallfantasies23</strong></span></li>
							</ul>
						</section>
						<section className="studio-contest__extra-item">
							<h2 className="text--small-title text--bold l-margin-bottom--sm"><i className="studio-contest__header-icon fas fa-fw fa-gift l-margin-right"/>Winners and Recognition</h2>
							<ul className="studio-contest__list-items dash-list-long">
								<li><span>All participating designs display the Fall Fantasies 2023 badge</span></li>
								<li><span>Winning designs display the Fall Fantasies 2023 winner badge.</span></li>
								{!isClosed && <li><span>Winners will be announced on <strong>December 5th, 2023</strong>. We’ll feature the winners on social media and in a future Studio Newsletter.</span></li>}
							</ul>
						</section>
					</div>
				}
			</article>
		);
	}

	renderDefault(activity, previewMode) {
		const content = previewMode ? activity.content : JSON.parse(activity.strContent);
		const isClosed = blapp.config.server_time >= activity.udtEndDate;
		const winnersAnnounced = blapp.config.server_time >= activity.udtWinDate;

		const {studioLanding, crossPromotion} = this.props;

		return (
			<article data-ts-name="studio-contest__header-block" style={{backgroundColor: content.bgColor}} className="studio-contest__header-block">
				{this.state.showModal ? this.renderModal() : null}
				<section className="studio-contest__intro">
					<div className="studio-contest__intro-body">
						{crossPromotion && winnersAnnounced ?
							<h1 className="studio-contest__intro-title">{crossPromotion.strActivityWinnersTitle}</h1>
						:
							<h1 className="studio-contest__intro-title">{content.strTitle}</h1>
						}
						{this.props.crossPromotion ? 
							winnersAnnounced ? 
								<div className="studio-contest__intro-copy l-margin-bottom--xl wysiwyg-content" dangerouslySetInnerHTML={{__html: crossPromotion.strActivityWinnersText}}/>
							:
								<div className="studio-contest__intro-copy l-margin-bottom--xl wysiwyg-content" dangerouslySetInnerHTML={{__html: crossPromotion.strActivityIntroBlurb}}/>
						:
							<div className="studio-contest__intro-copy l-margin-bottom--xl wysiwyg-content" dangerouslySetInnerHTML={{__html: content.strMainContent}}/>
						}

						{winnersAnnounced && crossPromotion ? 
							null
						:
							<div className="studio-contest__dates l-margin-bottom--xl">
								{!isClosed && 
									<div className="studio-contest__dates-item">
										<p className="studio-contest__dates-title">Activity starts</p>
										<p className="studio-contest__dates-date">{blapp.format.formatDateShort(activity.udtStartDate)}</p>
										<p className="studio-contest__dates-time">12:00 PM PT</p>
									</div>
								}
								<div className="studio-contest__dates-item">
									<p className="studio-contest__dates-title">{isClosed ? 'Activity ended' : 'Activity ends'}</p>
									<p className="studio-contest__dates-date">{blapp.format.formatDateShort(activity.udtEndDate)}</p>
									<p className="studio-contest__dates-time">12:00 PM PT</p>
								</div>
								{isClosed && 
									<div className="studio-contest__dates-item">
										<p className="studio-contest__dates-title">Winners announced</p>
										<p className="studio-contest__dates-date">{blapp.format.formatDateShort(activity.udtWinDate)}</p>
										<p className="studio-contest__dates-time">12:00 PM PT</p>
									</div>
								}
							</div>
						}
						{crossPromotion ? 
							<a href={blapp.url2.getStudioAcitivityUrl(this.props.slug)} className="studio-contest__cross-promotion-cta btn btn--yellow">{winnersAnnounced ? 'See winners' : 'Go to competition'}<i className="fas fa-long-arrow-right l-margin-left--sm"/></a>
						: 
							studioLanding ? 
								<a href={blapp.url2.getStudioAcitivityUrl(this.props.slug)} className="studio-contest__cross-promotion-cta btn btn--white text--normal">Go to activity<i className="fas fa-long-arrow-right l-margin-left--sm"/></a>
							:
								<button className="text--small-title btn btn--link" data-ts-name="show-contest-info__btn" onClick={() => this.setState({showContestInfo: !this.state.showContestInfo})}>{this.state.showContestInfo ? 'Hide' : 'Show'} details<i className={`fas fa-caret-${this.state.showContestInfo ? 'up' : 'down'} l-margin-left--sm`}/></button>
						}
					</div>
					<picture className="studio-contest__intro-image studio-contest__intro-image--default">
						<img src={content.urlImage} className="studio-contest__intro-image-item" alt="Studio gallery event"/>
					</picture>
				</section>
				{this.state.showContestInfo &&
					<div className="studio-contest__extra" data-ts-name="show-contest-info__content">
						<section className="studio-contest__extra-item studio-contest__extra-item--side-by-side">
							<div className="studio-contest__left-content">
								<h2 className="text--small-title text--bold l-margin-bottom--sm"><i className="studio-contest__header-icon fas fa-fw fa-clipboard-list l-margin-right"/>Design Requirements</h2>
								<div className="wysiwyg-content" dangerouslySetInnerHTML={{__html: content.strDesignRequirements}}></div>
							</div>
						</section>
						<section className="studio-contest__extra-item">
							<h2 className="text--small-title text--bold l-margin-bottom--sm"><i className="studio-contest__header-icon fas fa-fw fa-upload l-margin-right"/>How to Submit</h2>
							<div className="wysiwyg-content" dangerouslySetInnerHTML={{__html: content.strHowToSubmit}}></div>
							{activity.strActivityRules &&
								<React.Fragment>
									<p className="l-margin-top--xl l-margin-bottom"><strong>By submitting a model to the contest, you agree to all the terms in our Official Rules</strong></p>
									<button className="btn btn--cta text--bold l-inline-block" onClick={() => this.toggleRulesModal(activity.strActivityRulesTitle, activity.strActivityRules)}>View official rules</button>
								</React.Fragment>
							}
						</section>
						<section className="studio-contest__extra-item">
							<h2 className="text--small-title text--bold l-margin-bottom--sm"><i className="studio-contest__header-icon fas fa-fw fa-gift l-margin-right"/>Winners and Recognition</h2>
							<div className="wysiwyg-content" dangerouslySetInnerHTML={{__html: content.strWinnersAndRecognition}}></div>
						</section>
					</div>
				}
			</article>
		);
	}

	renderHoliday23() {
		const isClosed = blapp.config.server_time >= new Date('2024-01-03T12:00:00').getTime();

		return (
			<article data-ts-name="studio-contest__header-block studio-contest__header-block--holiday-23" className="studio-contest__header-block studio-contest__header-block--holiday-23">
				{this.state.showModal && this.state.modalType == 'holiday' ? this.renderModal() : null}
				<section className="studio-contest__intro">
					<div className="studio-contest__intro-body">
						<h1 className="studio-contest__intro-title text--xl-title">Build a Winter Wonderland</h1>
						<p className="text--small-title l-margin-bottom">Celebrate the season and capture the winter and holiday magic with LEGO bricks! Build what inspires you this time of year and share it on the Studio Gallery. Ideas include ornaments, snowmen, a nature scene, minifigures spreading holiday cheer, gifts and giving, or reflection and setting intention for the year to come.</p>
						<div className="studio-contest__dates l-margin-bottom--xl">
							{!isClosed && 
								<div className="studio-contest__dates-item">
									<p className="studio-contest__dates-title">Activity starts</p>
									<p className="studio-contest__dates-date">December 6</p>
									<p className="studio-contest__dates-time">12:00 PM PT</p>
								</div>
							}
							<div className="studio-contest__dates-item">
								<p className="studio-contest__dates-title">{isClosed ? 'Activity ended' : 'Activity ends'}</p>
								<p className="studio-contest__dates-date">January 3</p>
								<p className="studio-contest__dates-time">12:00 PM PT</p>
							</div>
							{isClosed && 
								<div className="studio-contest__dates-item">
									<p className="studio-contest__dates-title">Winners announced</p>
									<p className="studio-contest__dates-date">January 10</p>
									<p className="studio-contest__dates-time">12:00 PM PT</p>
								</div>
							}
						</div>
						<button className="text--small-title btn btn--link" data-ts-name="show-contest-info__btn" onClick={() => this.setState({showContestInfo: !this.state.showContestInfo})}>{this.state.showContestInfo ? 'Hide' : 'Show'} details<i className={`fas fa-caret-${this.state.showContestInfo ? 'up' : 'down'} l-margin-left--sm`}/></button>
					</div>
					<picture className="studio-contest__intro-image studio-contest__intro-image--holiday-23">
						<img src={"//" + blapp.config.getHost( "static2" ) + "/img/studio-gallery/holiday-23.png"} className="studio-contest__intro-image-item" alt="A Holiday ornament in the shape of a penguin. Designed by AlexanderGreene"/>
					</picture>
				</section>
				{this.state.showContestInfo &&
					<div className="studio-contest__extra" data-ts-name="show-contest-info__content">
						<section className="studio-contest__extra-item studio-contest__extra-item--side-by-side">
							<div className="studio-contest__left-content">
								<h2 className="text--small-title text--bold l-margin-bottom--sm"><i className="studio-contest__header-icon fas fa-fw fa-clipboard-list l-margin-right"/>Design Requirements</h2>
								<ul className="studio-contest__list-items dash-list-long l-margin-bottom">
									<li><span>25 to 500 total parts.</span></li>
									<li><span><strong>Bonus, but not required</strong>: Use the BDP Series 4 Palette. This will significantly bring down the price of parts if you plan to realize your creation.</span></li>
								</ul>
							</div>
							<div className="studio-contest__right-content">
								<article className="studio-contest__callout">
									<h2 className="text--small-title text--bold l-margin-bottom--sm"><i className="far fa-ornament l-margin-right--sm"/>Want to build an ornament?</h2>
									<p className="l-margin-bottom">Need some inspiration? We’ve included a template for an optional ornament base to help you get started.</p>
									<p><a href="https://bricklink.download.bricklink.info/brick_ornament_template.io">Download template</a></p>
								</article>
							</div>
						</section>
						<section className="studio-contest__extra-item">
							<h2 className="text--small-title text--bold l-margin-bottom--sm"><i className="studio-contest__header-icon fas fa-fw fa-upload l-margin-right"/>Submission Specifications</h2>
							<ul className="studio-contest__list-items dash-list-long">
								<li>Upload your design by January 3rd, 2024 at 12:00 pm, Pacific Time</li>
								<li>All photo submissions must be rendered images that are 1280x960 px max and 4:3 dimensions.</li>
								<li><span>Select <strong>Partial Access</strong> or <strong>Full Access</strong></span></li>
								<li><span>To enter, you must add the <strong>winterwonderland23</strong> tag</span></li>
								<li><span>Designs must be 100% original and not use third-party IP</span></li>
								<li><span><strong>Extra credit:</strong> Build it for real and share on Instagram! Take a photo of your design and post using the hashtag <strong>#winterwonderland2</strong></span></li>
							</ul>
						</section>
						<section className="studio-contest__extra-item">
							<h2 className="text--small-title text--bold l-margin-bottom--sm"><i className="studio-contest__header-icon fas fa-fw fa-gift l-margin-right"/>Winners and Recognition</h2>
							<ul className="studio-contest__list-items dash-list-long">
								<li><span>All participating designs display the Build a Winter Wonderland badge.</span></li>
								<li><span>Winning designs display the Build a Winter Wonderland winner badge.</span></li>
								<li><span>Winners announced on <strong>January 10, 2024 at 12:00pm, Pacific Time</strong>. We’ll feature the winners on social media and in a future Studio Newsletter.</span></li>
							</ul>
						</section>
					</div>
				}
			</article>
		);
	}

	renderBDPSeries1() {
		const isClosed = blapp.config.server_time >= new Date('2024-01-31T12:00:00').getTime();
		const winnersAnnounced = blapp.config.server_time >= new Date('2024-02-06T12:00:00').getTime();

		return (
			<article data-ts-name="studio-contest__header-block studio-contest__header-block--series1minibuild" className="studio-contest__header-block studio-contest__header-block--series1minibuild">
				{this.state.showModal && this.state.modalType == 'series1minibuild' ? this.renderModal() : null}
				<section className="studio-contest__intro">
					<div className="studio-contest__intro-body">
						{this.props.crossPromotion && winnersAnnounced ? 
							<h1 className="studio-contest__intro-title">Congratulations to BDP Series 1 Mini-Build winners!</h1>
						:
							<h1 className="studio-contest__intro-title">BDP Series 1 Mini-Build Competition</h1>
						}
						{this.props.crossPromotion ? 
							winnersAnnounced ? 
								<p className="studio-contest__intro-copy l-margin-bottom--xl">Check out the winners—tiny builds that make a big impression!</p>
							:
								<p className="studio-contest__intro-copy l-margin-bottom">Showcase your creativity, hone your building skills, and celebrate the splendor of the BDP Series 1 Finalist models!</p>
						:
							<p className="studio-contest__intro-copy l-margin-bottom">You're invited to build and share your mini version of a Series 1 Finalist during our new activity! Dust off your shrink-ray and flex your design muscles for this challenge. Showcase your creativity, hone your building skills, and celebrate the splendor of the BDP Series 1 Finalist models! </p>
						}
						{winnersAnnounced && this.props.crossPromotion ? 
							null
						:
							<div className="studio-contest__dates l-margin-bottom--xl">
								{!isClosed && 
									<div className="studio-contest__dates-item">
										<p className="studio-contest__dates-title">Activity starts</p>
										<p className="studio-contest__dates-date">January 11</p>
										<p className="studio-contest__dates-time">12:00pm PT</p>
									</div>
								}
								<div className="studio-contest__dates-item">
									<p className="studio-contest__dates-title">{isClosed ? 'Activity ended' : 'Activity ends'}</p>
									<p className="studio-contest__dates-date">January 31</p>
									<p className="studio-contest__dates-time">12:00pm PT</p>
								</div>
								{isClosed && 
									<div className="studio-contest__dates-item">
										<p className="studio-contest__dates-title">Winners announced</p>
										<p className="studio-contest__dates-date">February 6</p>
										<p className="studio-contest__dates-time">12:00pm PT</p>
									</div>
								}
							</div>
						}
						{this.props.crossPromotion ? 
							<a href={blapp.url2.getStudioAcitivityUrl(this.props.slug)} className="studio-contest__cross-promotion-cta btn btn--yellow">{winnersAnnounced ? 'See winners' : 'Go to competition'}<i className="fas fa-long-arrow-right l-margin-left--sm"/></a>
						: 
							<button className="text--small-title btn btn--link" data-ts-name="show-contest-info__btn" onClick={() => this.setState({showContestInfo: !this.state.showContestInfo})}>{this.state.showContestInfo ? 'Hide' : 'Show'} details<i className={`fas fa-caret-${this.state.showContestInfo ? 'up' : 'down'} l-margin-left--sm`}/></button>
						}
					</div>
					<picture className="studio-contest__intro-image studio-contest__intro-image--holiday-23">
						<img src={"//" + blapp.config.getHost( "static2" ) + `/img/studio-gallery/bdp-mini-build-1${this.props.crossPromotion ? '' : '-yellow'}.png`} className="studio-contest__intro-image-item" alt="Minibuilds of a fishing boat and windmill"/>
					</picture>
				</section>
				{this.state.showContestInfo &&
					<div className="studio-contest__extra" data-ts-name="show-contest-info__content">
						<section className="studio-contest__extra-item studio-contest__extra-item--side-by-side">
							<div className="studio-contest__left-content">
								<h2 className="text--small-title text--bold l-margin-bottom--sm"><i className="studio-contest__header-icon fas fa-fw fa-clipboard-list l-margin-right"/>Design Requirements</h2>
								<ul className="studio-contest__list-items dash-list-long l-margin-bottom">
									<li><span>10 to 300 total parts.</span></li>
									<li><span>Use the BDP Series 1-4 Palettes</span></li>
									<li><span>Two dimensions (Length x Width x Height) should be 8 studs/bricks or less. </span></li>
								</ul>
								<article className="l-border border-color--primaryBlue l-flex notification notification--notice">
									<i className="fas fa-question-circle notification__icon l-margin-right l-margin-top--sm text--small-title"/>
									<p><strong>Need some inspiration?</strong> Use Studio’s Reference Image feature and utilize one of your favorite Finalist model photos. <a href="https://studiohelp.bricklink.com/hc/en-us/articles/15341721435799-Reference-Image" className="text--bold">Learn more</a></p>
								</article>
							</div>
						</section>
						<section className="studio-contest__extra-item">
							<h2 className="text--small-title text--bold l-margin-bottom--sm"><i className="studio-contest__header-icon fas fa-fw fa-upload l-margin-right"/>How to Submit</h2>
							<ul className="studio-contest__list-items dash-list-long">
								<li>Upload your design by Jan 31st, 2023 at 12:00 pm Pacific US Time</li>
								<li><span>By submitting a model to the contest, you agree to all the terms in our <button className="btn btn--link" onClick={() => this.toggleModal('series1minibuild')}>Official Rules</button></span></li>
								<li>All photo submissions must be rendered images that are 1280x960px max and 4:3 dimensions. Do not add any additional graphics to render</li>
								<li><span>Select <strong>Partial Access</strong> or <strong>Full Access</strong></span></li>
								<li><span>To enter, you must add the <strong>series1minibuild</strong> tag</span></li>
								<li><span>Designs must be 100% original</span></li>
								<li><span><strong>Extra credit:</strong> Build it for real and share on Instagram! Take a photo of your design and post using the hashtag <strong>#BLseries1minibuild</strong></span></li>
							</ul>
						</section>
						<section className="studio-contest__extra-item">
							<h2 className="text--small-title text--bold l-margin-bottom--sm"><div className="studio-contest__header-icon l-margin-right"><BDPIcon classes="studio-contest__header-icon-bdp"/></div>Winners and Recognition</h2>
							<ul className="studio-contest__list-items dash-list-long">
								<li><span>All participating designs display the BDP Series 1 Mini-Build badge</span></li>
								<li><span>Winners announced on <strong>February 6th, 2024 at 12:00pm, Pacific Time</strong>. We’ll feature the winners on social media.</span></li>
								<li><span>One winning design for each of the five Series 1 Finalist models will receive a copy of the Series 1 Finalist set that their model represents (to ship at product launch in July 2024).</span></li>
							</ul>
						</section>
					</div>
				}
			</article>
		);
	}

	renderModal() {
		switch(this.state.modalType) {
			case 'holiday':
				return this.renderHolidayModal();
				break;

			case 'series1minibuild':
				return this.renderBDPToSModal();
				break;

			case 'activityRules':
				return this.renderActivityRules();
				break;
		}
	}

	renderHolidayModal() {
		return (
			<ModalFrame title={'BrickLink Common Palette'} classes={"studio-contest__holiday-modal"} footer={{buttons: [{type: 'cta', align: 'right', text: 'Done', onClickFunc: () => this.toggleModal('holiday')}]}} closeFunc={() => this.toggleModal('holiday')}>
				<section className="studio-contest__holiday-modal-block">
					<h2 className="studio-contest__holiday-modal-block-title">
						<span className="studio-contest__holiday-modal-block-number">1</span>
						Open up Studio app and choose the BrickLink Common Palette
					</h2>
					<div className="studio-contest__holiday-modal-image">
						<img src={"//" + blapp.config.getHost( "static2" ) + "/img/studio-gallery/studio-common-palette.png"} alt="BrickLink Common Palette menu item"/>
					</div>
				</section>
				<section className="studio-contest__holiday-modal-block">
					<h2 className="studio-contest__holiday-modal-block-title">
						<span className="studio-contest__holiday-modal-block-number">2</span>
						Use parts and colors from the BrickLink Common Palette
					</h2>
					<div className="studio-contest__holiday-modal-callout l-flex l-start">
						<i className="fas fa-exclamation-circle text-color--primaryYellow l-margin-right text--title l-margin-top--xs"/>
						<p className="text--small-title">If you use the color picker and change a part to a color that is not within the BrickLink Common Palette, it may change the price and part availability.</p>
					</div>
				</section>
			</ModalFrame>
		);
	}

	renderBDPToSModal() {
		return (
			<ModalFrame title={'LEGO® BrickLink Designer Program Series 1 Mini-Build Challenge'} classes={"studio-contest__bdp-tos-modal"} closeFunc={() => this.toggleModal('holiday')}>
				<h2 className="text--bold l-margin-bottom">
					Please carefully read the Official Rules and Privacy Notice below.
				</h2>
				<section className="studio-contest__bdp-tos-content scroll-container l-full-width">
					<div className="base-formating">
						<p>The Official Rules are below, but first we want to talk about your privacy. We want you to know what personal data of yours we collect, how we use your personal data, who we share it with, and how long we plan to keep it. For purposes of running this contest and selecting a potential winner, we need to collect certain information, or in the case of existing BrickLink members, utilize certain information previously provided to us. Here is the personal data we require of each entrant:</p>
						<ul className="l-margin-left--xl">
							<li>Name</li>
							<li>Mailing address</li>
							<li>Email address</li>
							<li>Phone number (optional but may be helpful in case of prize delivery difficulties)</li>
						</ul>
						<p>We will use the personal data listed above, and share it with selected third parties, only for the following purposes:</p>
						<ul className="l-margin-left--xl">
							<li>To publicly announce the winners of the prize drawing</li>
							<li>To ship the prize to the Winner</li>
							<li>To demonstrate compliance with applicable laws and regulations covering prize drawings</li>
						</ul>
						<p>The types of third parties we will share your personal data with are:</p>
						<ul className="l-margin-left--xl">
							<li>Regulatory authorities or auditors assessing our compliance with laws and regulations</li>
							<li>Cloud Storage Companies used by the LEGO Group</li>
							<li>Delivery service for delivering the prize</li>
						</ul>
						<p>We will delete your data when it is no longer needed for contest administration or legally required recordkeeping, but in any case no later than three years after the date it is collected.</p>
						<p>We realize that you might still have questions regarding how we use your personal information. To learn more about how we collect your personal information, who we share it with, how you can correct it, and how you can ask us to stop using it, please see the LEGO Group Privacy policy at <a href="http://aboutus.lego.com/enus/corporate/privacypolicy.aspx" target="_blank">http://aboutus.lego.com/enus/corporate/privacypolicy.aspx</a> and the LEGO BrickLink Privacy Policy at <a href="https://www.bricklink.com/v3/privacy_policy.page" target="_blank">https://www.bricklink.com/v3/privacy_policy.page</a>. In case of any inconsistency between the two policies, we will apply the provisions of the Privacy Policy that is more protective of Entrant’s data privacy rights.</p>
						<h2 className="l-margin-top--xl">Official Rules</h2>
						<ol>
							<li><strong>Overview</strong>: Fan designers will participate in a digital LEGO® brick building contest designing replica mini-builds of the BrickLink Designer Program Series 1 Finalists. This event is to promote the upcoming launch of Pre-Orders for BrickLink Designer Program Series 1. Entries will be judged by members of the LEGO Group’s BrickLink Designer Program Team and Series 1 Finalist Designers. The winner will receive a copy of the BDP set that their model depicts.</li>
							<li>
								<p>This Competition is sponsored by LEGO System A/S, Aastvej 1, 7190 Billund, Denmark.</p>
								<p><strong>By participating in this Competition, Entrants agree to be bound by these Official Rules.</strong></p>
							</li>
							<li>
								<p><strong>Eligibility</strong>: To enter this Competition you must be at least 18 years old and an adult by the laws of your country of residence, and a resident of one of the following countries:</p>
								<p className="l-margin-left--xl">Argentina, Australia, Austria, Belgium, Canada, Colombia, Denmark, Estonia, Finland, Finland, France (excluding French Overseas Departments or Territories and the Principality of Monaco), Germany (excluding Heligoland), Greece, India, Ireland, Japan, Latvia, Lithuania, Luxembourg, Mexico, Netherlands, New Zealand, Norway, Poland, Portugal, Romania, Singapore, Slovakia, Slovenia, South Korea, Spain, Sweden, Switzerland, Thailand, the United Kingdom, or the United States.</p>
								<p>No Entrant may be an employee, partner or immediate family member of an employee of the LEGO Group or any third-party company or agency directly connected with the creation or administration of this Promotion.</p>
							</li>
							<li><strong>Entry period</strong>: This Competition will take place between January 11th, 2024, and January 31st, 2024 (the “Entry Period”). Entries must be submitted within the Entry Period. Any Entries received after this time shall not be valid.</li>
							<li><strong>How to enter</strong>: During the Entry Period, Entrants must follow instructions provided on the Studio Activities webpage to create a digital LEGO brick model using the Studio app reflecting one of the five Finalist models for BrickLink Designer Program Series 1.</li>
							<li>
								<p><strong>Limitation on entry</strong>: One design per Finalist model per Entrant during the Entry Period. If more than one Entry per Finalist model per participant is received during the Entry Period, only the first Entry will be included and later Entries for that Finalist Model will be disqualified.</p>
								<p>All Entries must adhere to the following Guidelines and Content Restrictions.</p>
								<p><u>Guidelines and Content Restrictions:</u></p>
								<ul className="l-margin-left--xl">
									<li>The Entry must utilize the Studio app and images of the model must include renders from the Studio app.</li>
									<li>Models may only use elements from and of the active BrickLink Designer Program Series palettes (Series 1-4).</li>
									<li>Models must be made in a miniature scale. Models should be limited to a maximum of 8 studs/bricks in two of the three dimensions (Length x Width x Height). For example, a model could be 16 studs wide, if the model was also less then 8 studs long and 8 bricks high. A model could be 8 studs wide and 8 studs long, but 12 bricks high.</li>
									<li>All Entries must be submitted by end of day on January 31st 2024.</li>
									<li>The Entry cannot have been previously published or submitted in any Competition of any kind.</li>
									<li>The Entry must not contain material that violates or infringes another’s rights, including without limitation, privacy, publicity, or intellectual property rights infringement (not including copying of the original design, which is explicitly permitted for purposes of this Competition);</li>
									<li>The Entry must not disparage BrickLink, or any other person or party affiliated with the Competition.</li>
									<li>The Entry must consist of a miniature digital brick-built model of a Finalist model for BrickLink Designer Program Series 1, reflecting the themes of this Competition. All entries must be created within BrickLink’s Studio app, which may be accessed and downloaded at BrickLink.com. Entries must not show any identifiable feature of any product, trademark, or copyrighted property of any other person or business entity.</li>
								</ul>
							</li>
							<li>
								<strong>Intellectual Property</strong>: By submitting an Entry, Entrants grant BrickLink a royalty-free, irrevocable, perpetual (or for the entire term of duration of intellectual property rights), non-exclusive, sub-licensable license to use, reproduce, modify, publish, and display such Entry in whole or in part, on a worldwide basis, and to incorporate it into other works, in any form, media or technology now known or later developed for competition or marketing purposes of BrickLink's products. If requested, entrant agrees to sign any documentation that may be required for BrickLink or its designees to fully exploit the above-referenced license grant to the Entry. In granting BrickLink such license, Entrant will represent and warrant that the Entry remains unpublished and does not in any way infringe upon any third party’s intellectual property rights.
							</li>
							<li><strong>Prize</strong>: The Winner for each of the five models will receive a copy of the BrickLink Designer Program set that their model depicts. Estimated retail value will vary based on the model but will be no more than $500 USD. The prize is non-transferable and no cash alternative is available. The prize is subject to availability (if, for example, the reference model does not surpass the minimum pre-order threshold and is therefore not produced) and BrickLink reserves the right to substitute the prize for an alternative prize of equal or greater value.</li>
							<li>
								<p><strong>Selection of Winner and Odds of Winning</strong>: The Potential Winners will be selected by the members of the LEGO Group’s BrickLink Designer Program Team and Series 1 Finalist Designers (the “Judges”). Entries will be evaluated according to the following criteria:</p>
								<p><strong>Likeness to the original reference model 80%</strong></p>
								<p><strong>Originality and clever usage of elements 20%</strong></p>
								<p>The odds of winning will depend on the skill and talent of the Entrant, as assessed by the Judges. The Potential Winner selection will take place on February 1st 2024. Potential Winner must meet all eligibility requirements, and must complete and return a “Winner’s Statement,” consisting of a Statement of Eligibility and Prize Acceptance, a Release of Liability, and a Publicity Release, to the extent permitted by local law. If the selected Winner is unavailable or is found to be ineligible, a new Potential Winner will be selected from all remaining eligible Entries received, in accordance with the Selection procedure above.</p>
							</li>
							<li><strong>Award of Prize</strong>: The Judges will announce the winners on February 6th, 2024 on the activity page. Prizes will be awarded when the BrickLink Designer Program Series 1 sets are released, which is expected to be in July, 2024, but may be later in case of production delays.</li>
							<li>
								<p><strong>Data Privacy</strong>: By entering the Competition, Entrants agree to their personal information being used for the purposes described in these Official Rules and in accordance with the Privacy Policies of the LEGO Group and of LEGO BrickLink, Inc.., which can be found at <a href="http://aboutus.lego.com/enus/corporate/privacypolicy.aspx" target="_blank">http://aboutus.lego.com/enus/corporate/privacypolicy.aspx</a>. In case of inconsistency between the two, Sponsor will apply the provisions of the policy that is more protective of the Entrant’s data privacy rights.</p>
								<p>The company responsible for handling all privacy data is LEGO System A/S, Aastvej 1, 7190 Billund, Denmark.</p>
								<p><strong>By entering the Competition, Entrants acknowledge that they have read and understand the Privacy Policy and agree to its terms.</strong></p>
							</li>
							<li>
								<p><strong>Additional Rules:</strong></p>
								<ul className="l-margin-left--xl">
									<li>Entries will not be returned. All Entries shall become the property of BrickLink and may be used for other marketing activities.</li>
									<li>Winner agrees to BrickLink’s use of Winner’s BrickLink username and county of residence to announce the Winner of this Promotion.</li>
									<li>The BrickLink shall not have any liability and does not accept any damage, loss, injury or disappointment suffered by Entrants of this Promotion to the extent permitted by law. Nothing shall exclude the BrickLink’s liability for death and personal injury as a result of its negligence.</li>
									<li>Any Entry made or attempted in a manner which in the BrickLink’s reasonable opinion is contrary to the spirit of these Official Rules, or by its nature is unfair to other Entrants, will be invalid and may result in disqualification from the Competition.</li>
									<li>Reporting prize winnings and paying any applicable taxes, governmental fees, and other expenses resulting from winning a prize are the sole responsibility of the Prize Winner unless otherwise stated; Winner is encouraged to check local tax implications.</li>
									<li>These Official Rules shall be governed and construed in accordance with the laws of Denmark.</li>
								</ul>
							</li>
						</ol>
						<p className="l-margin-top--xl">LEGO is a trademark of the LEGO Group. © 2023 The LEGO Group.</p>
					</div>
				</section>
			</ModalFrame>
		);
	}

	renderActivityRules() {
		const {activityRules, activityRulesTitle} = this.state;

		return (
			<ModalFrame title={activityRulesTitle} classes={"studio-contest__bdp-tos-modal"} closeFunc={() => this.toggleModal('activityRules')}>
				<h2 className="text--bold l-margin-bottom">
					Please carefully read the Official Rules and Privacy Notice below.
				</h2>
				<section className="studio-contest__bdp-tos-content scroll-container l-full-width">
					<div className="base-formating" dangerouslySetInnerHTML={{__html: activityRules}}/>
				</section>
			</ModalFrame>
		);
	}

	toggleModal(type) {
		blapp.screen.toggleScroll(!this.state.showModal);
		this.setState({showModal: !this.state.showModal, modalType: this.state.modalType == type ? '' : type});
	}

	toggleRulesModal(title, rules) {
		this.setState({activityRules: rules, activityRulesTitle: title}, () => this.toggleModal('activityRules'));
	}

}